import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-shop-live',
  templateUrl: './shop-live.component.html',
  styleUrls: ['./shop-live.component.css']
})
export class ShopLiveComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }
}
